{
  "gemini-2.5-pro": {
    "modelName": "gemini-2.5-pro",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": 200000,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.25,
            "outputPricePerMillion": 10
          }
        }
      },
      {
        "minTokens": 200001,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 2.5,
            "outputPricePerMillion": 15
          }
        }
      }
    ]
  },
  "gemini-3.1-pro-preview": {
    "modelName": "gemini-3.1-pro-preview",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": 200000,
        "prices": {
          "base": {
            "inputPricePerMillion": 2,
            "outputPricePerMillion": 12
          }
        }
      },
      {
        "minTokens": 200001,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 4,
            "outputPricePerMillion": 18
          }
        }
      }
    ]
  },
  "gemini-3.1-pro-preview-customtools": {
    "modelName": "gemini-3.1-pro-preview-customtools",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": 200000,
        "prices": {
          "base": {
            "inputPricePerMillion": 2,
            "outputPricePerMillion": 12
          }
        }
      },
      {
        "minTokens": 200001,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 4,
            "outputPricePerMillion": 18
          }
        }
      }
    ]
  },
  "gemini-2.5-flash": {
    "modelName": "gemini-2.5-flash",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.3,
            "outputPricePerMillion": 2.5
          }
        }
      }
    ]
  },
  "gemini-2.5-flash-lite": {
    "modelName": "gemini-2.5-flash-lite",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.1,
            "outputPricePerMillion": 0.4
          }
        }
      }
    ]
  },
  "gemini-3-flash-preview": {
    "modelName": "gemini-3-flash-preview",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.5,
            "outputPricePerMillion": 3
          }
        }
      }
    ]
  },
  "gemini-3.5-flash": {
    "modelName": "gemini-3.5-flash",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.5,
            "outputPricePerMillion": 9
          }
        }
      }
    ]
  },
  "gemini-3.1-flash-lite": {
    "modelName": "gemini-3.1-flash-lite",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.25,
            "outputPricePerMillion": 1.5
          }
        }
      }
    ]
  },
  "gemini-3.6-flash": {
    "modelName": "gemini-3.6-flash",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.5,
            "outputPricePerMillion": 7.5
          }
        }
      }
    ]
  },
  "gemini-3.5-flash-lite": {
    "modelName": "gemini-3.5-flash-lite",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.3,
            "outputPricePerMillion": 2.5
          }
        }
      }
    ]
  }
}
